import {
  detail,
  detailMore,
  evaluationList,
  loadGoods,
  getFreightAmount,
  getAd,
  addCart,
  findBoIdByGoodsId,
  checkGoods,
  insertGoodsGroupPurchase,
  genBill,
  getIsAddrSupport,
  updateAddr,
  addAddr,
  shopDeliveryList,
  getShopCoupon,
  buyskip,
  getLiveList,
  saveVisitRecord,
  alterDelivery,
  deleteAddr,
  getAddTaskGrantPoints,
  getGoodsSkuId
} from "@/api/goodDetails/goodDetails";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async detail(context, params) {
      const data = await detail(params);
      return data;
    },
    async evaluationList(context, params) {
      const { data } = await evaluationList(params);
      return data;
    },
    async detailMore(context, params) {
      const data = await detailMore(params);
      return data;
    },
    async loadGoods(context, params) {
      const { data } = await loadGoods(params);
      return data;
    },
    async getFreightAmount(context, params) {
      const { data } = await getFreightAmount(params);
      return data;
    },
    async getAd(context, params) {
      const { data } = await getAd(params);
      return data;
    },
    async addCart(context, params) {
      const data = await addCart(params);
      return data;
    },
    async findBoIdByGoodsId(context, params) {
      const data = await findBoIdByGoodsId(params);
      return data;
    },
    async checkGoods(context, params) {
      const data = await checkGoods(params);
      return data;
    },
    async insertGoodsGroupPurchase(context, params) {
      const data = await insertGoodsGroupPurchase(params);
      return data;
    },
    async genBill(context, params) {
      const data = await genBill(params);
      return data;
    },
    async getIsAddrSupport(context, params) {
      const data = await getIsAddrSupport(params);
      return data;
    },
    async updateAddr(context, params) {
      const data = await updateAddr(params);
      return data;
    },
    async addAddr(context, params) {
      const data = await addAddr(params);
      return data;
    },
    async shopDeliveryList(context, params) {
      const data = await shopDeliveryList(params);
      return data;
    },
    async getShopCoupon(context, params) {
      const data = await getShopCoupon(params);
      return data;
    },
    async buyskip(context, params) {
      const data = await buyskip(params);
      return data;
    },
    async getLiveList(context, params) {
      const data = await getLiveList(params);
      return data;
    },
    async saveVisitRecord(context, params) {
      const data = await saveVisitRecord(params);
      return data;
    },
    async alterDelivery(context, params) {
      const data = await alterDelivery(params);
      return data;
    },
    async deleteAddr(context, params) {
      const data = await deleteAddr(params);
      return data;
    },
    async getAddTaskGrantPoints(context, params) {
      const data = await getAddTaskGrantPoints(params);
      return data;
    },

    async getGoodsSkuId(context, params) {
      const { data } = await getGoodsSkuId(params);
      return data;
    }
  }
};
